import * as angular from "angular";
import { LoginService } from "../../services/login.service";
import { Filter } from "../../models/filter.model";

let AdminLoginsComponent = {
    selector: "vcAdminLogins",
    templateUrl: "/angular/components/admin/admin-logins.component.html",
    bindings: {},
    controller: class AdminLoginsController {
        private readonly $scope: any;
        private readonly $timeout: any;
        private timeoutCode: any;
        private service: LoginService;

        /** Shared shape with the other admin pages so vc-admin-tabs can drive it. */
        public filter = new Filter({
            search: { values: "", checked: true },
            thisRegion: null,
        });
        public loading = false;
        public scrollLoading = false;
        public exhausted = false;
        public logins: any[] = [];
        public loginid = 0;

        constructor($scope: any, $timeout: any, LoginService: LoginService) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.service = LoginService;
            this.loadLogins();
        }

        $onInit() {
            this.$scope.$watch(
                () =>
                    JSON.stringify([
                        this.filter.search && this.filter.search.values,
                        this.filter.result,
                    ]),
                (newValue: string, oldValue: string) => {
                    if (oldValue && newValue !== oldValue) {
                        this.$timeout.cancel(this.timeoutCode);
                        this.timeoutCode = this.$timeout(() => {
                            this.loadLogins();
                        }, 500);
                    }
                }
            );
        }

        /** Query shape the v1 login endpoint reads: search string + result. */
        private query(): object {
            return {
                search: (this.filter.search && this.filter.search.values) || "",
                result: this.filter.result || null,
            };
        }

        private trackLastId(): void {
            this.loginid = this.logins.length
                ? this.logins[this.logins.length - 1].loginid
                : 0;
        }

        loadLogins(): void {
            this.loading = true;
            this.exhausted = false;
            this.service
                .all({ id: 0, filter: this.query() })
                .then((response: object) => {
                    const json = response["data"];
                    this.loading = false;
                    this.logins = json.success ? json.data : [];
                    this.trackLastId();
                });
        }

        scrollLoad(): void {
            if (!this.scrollLoading && !this.exhausted && this.loginid) {
                this.scrollLoading = true;
                this.service
                    .all({ id: this.loginid, filter: this.query() })
                    .then((response: object) => {
                        const json = response["data"];
                        if (json.success && json.data.length) {
                            this.logins = this.logins.concat(json.data);
                            this.trackLastId();
                        } else {
                            this.exhausted = true;
                        }
                        this.scrollLoading = false;
                    });
            }
        }
    },
};

angular
    .module("admin")
    .component(AdminLoginsComponent.selector, AdminLoginsComponent);
